import { render, staticRenderFns } from "./DataAssetsManage.vue?vue&type=template&id=26a0ed96&scoped=true"
import script from "./DataAssetsManage.vue?vue&type=script&lang=js"
export * from "./DataAssetsManage.vue?vue&type=script&lang=js"
import style0 from "./DataAssetsManage.vue?vue&type=style&index=0&id=26a0ed96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a0ed96",
  null
  
)

export default component.exports